import {
  Identifiable,
  Planzone,
  ProjectMembersListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateProjectMembersListingConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: ProjectMembersListingConfiguration,
    nextConfiguration: ProjectMembersListingConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          projectMembersListingViewConfigurations:
            JSON.stringify(nextConfiguration),
        },
      },
    });
}

export { updateProjectMembersListingConfiguration };
